import { Dialog, FormLabel, Heading, Loader } from "@/components"
import useManagerialReport from "./useManagerialReport";
import { Button, Input } from "@/components/ui";
import { LoadVariant } from "./LoadVariant";
import { ResultView } from "./ResultView";
import { FormView } from "./FormView";

const ManagerialReport = () => {
  const { breadcrumbData, form, formData, openLoadVariantDialog , setOpenLoadVariantDialog,
    docTypeList, isLoading, glMasterList, objectValues, onReset, onLoadVariant, onLoadConfirm,
    openSaveDialog, setOpenSaveDialog, variantName, setVariantName, onSave, onUpdate, selectedVariantId,
    isAddPending, isUpdatePending, onSubmit, onSaveBtnClick, isLoadingDropdown, isRunning, result, ranWith,
    appliedLabels, onEditCriteria, communityName, financialVersionOptions, budgetVersionOptions,
    accountCategoryOptions, reportLevelOptions,
   } = useManagerialReport();

  return (
    <div className="p-4">
      <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <Heading title={<span>Managerial Reporting{communityName ? ` - ${communityName}` : ""}
          {ranWith?.fiscalYear ? <span className="text-[12px]"> (FY-{ranWith.fiscalYear})</span> : null}</span>} breadcrumbData={breadcrumbData} />
      </div>

      {result ? <ResultView result={result} criteria={ranWith} appliedLabels={appliedLabels}
        onEditCriteria={onEditCriteria} communityName={communityName} /> : <FormView
        isLoading={isLoading}
        isRunning={isRunning}
        financialVersionOptions={financialVersionOptions}
        budgetVersionOptions={budgetVersionOptions}
        accountCategoryOptions={accountCategoryOptions}
        reportLevelOptions={reportLevelOptions}
        onReset={onReset}
        onLoadVariant={onLoadVariant}
        onSaveBtnClick={onSaveBtnClick}
        form={form}
        onSubmit={onSubmit}
        objectValues={objectValues}
        isLoadingDropdown={isLoadingDropdown}
        formData={formData}
        docTypeList={docTypeList}
        glMasterList={glMasterList}
      />}
      
      
      {openLoadVariantDialog && <LoadVariant
        open={openLoadVariantDialog}
        setOpen={setOpenLoadVariantDialog}
        onLoadConfirm={onLoadConfirm}
      />}
      <Dialog
        open={openSaveDialog}
        setOpen={setOpenSaveDialog}
        title={<div className="text-2xl font-bold text-primary">
          {"Save Variant"}
          <div className="h-1 w-[30%] bg-primary rounded-full" />
        </div>}
        hideFooter
      >
        <div className="flex flex-col">
          <div className="relative">
            <FormLabel>
              {"Variant Name"}
              <span className="text-red-700">{"*"}</span>
            </FormLabel>
            <Input
              type="text"
              placeholder="Please Enter"
              value={variantName}
              onChange={(e) => setVariantName(e.target.value)}
              className="bg-white h-[40px]"
            />
          </div>
          <span className="text-[10px] text-gray-500 mb-5">Update the loaded variant, or save this as a separate new one.</span>
          <div className="flex items-center justify-end">
            <Button type="button" onClick={onSave} disabled={isAddPending || isUpdatePending}>{isAddPending ? <Loader variant="secondary" /> : <></>} {selectedVariantId ? "Save as New" : "Save"}</Button>
            {selectedVariantId ? <Button type="button" onClick={onUpdate} disabled={isAddPending || isUpdatePending}>{isUpdatePending ? <Loader variant="secondary" /> : <></>} Update</Button> : <></>}
          </div>
        </div>
      </Dialog>
    </div>
  )
}

export default ManagerialReport;
